<script setup lang="ts">
import {MinusIcon, PlusIcon} from "lucide-vue-next";
import type {Ref} from "vue";
import {computed, ref} from "vue";

type Size = 'small' | 'large';

interface Props {
    value: number,
    min?: number
    size?: Size
}
const props = withDefaults(defineProps<Props>(), {
    min: 1,
    size: 'large'
});
const value: Ref<number> = ref(props.value);

const emit = defineEmits<(e: 'input', value: number) => void>();

const updateInput = () => {
    let amount = value.value;
    if (amount <= 0) amount = 1;
    emit('input', amount);
}
const incrementAmount = () => {
    value.value++;
    updateInput();
}
const decrementAmount = () => {
    value.value--;
    if (value.value <= 0) value.value = 1;
    updateInput();
}
</script>

<template>

    <div class="inline-flex items-center overflow-hidden rounded-full border border-gray-200 bg-white">
        <button type="button" @click.prevent="decrementAmount"
                class="inline-flex h-14 w-10 items-center justify-center border-r border-gray-200 text-secondary-500 transition hover:bg-secondary-50"
                aria-label="Aantal verlagen">
            <MinusIcon class="h-4 w-4" />
        </button>
        <input type="number" min="1" v-model="value" @change="updateInput"
               class="min-w-[4rem] w-16 border-0 bg-transparent text-center text-sm font-medium text-secondary-700 outline-none ring-0 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none">
        <button type="button" @click.prevent="incrementAmount"
                class="inline-flex h-14 w-10 items-center justify-center border-l border-gray-200 text-secondary-500 transition hover:bg-secondary-50"
                aria-label="Aantal verhogen">
            <PlusIcon class="h-4 w-4" />
        </button>
    </div>
</template>
